import type { Bundle } from '@schibsted/frapi-schema';
import type { FrapiTeaserItem } from '../types/frapi-types.js';

export const flattenFeed = (
  feed: (FrapiTeaserItem | Bundle<FrapiTeaserItem>)[],
): FrapiTeaserItem[] => {
  const teasers: FrapiTeaserItem[] = [];

  Object.values(feed).forEach((item) => {
    if (item.type === 'teaser') {
      teasers.push(item);
    } else if (item.type === 'bundle') {
      teasers.push(...flattenFeed(item.items));
    }
  });

  return teasers;
};
